import {find as _find, each as _each} from 'lodash';
import {Utils} from './Utils'
import {StringUtils} from "./StringUtils";

export type IHashItem = {
    name: string;
    value: string;
};

export class UriHelper {

    public static setTimeStamp(url: string, timestamp: string = null, timeStampKey: string = '_t'): string {
        var uri = URI(url);
        timeStampKey = Utils.valueOrDefault(timeStampKey, '_t');
        timestamp = Utils.valueOrDefault(timestamp, new Date().toString());
        uri.setQuery(timeStampKey, timestamp);
        return uri.toString();
    }

    public static setQueryString(url: string, queryStringObject: Object): string {
        var uri = URI(url);
        for (var key in queryStringObject) {
            if (queryStringObject.hasOwnProperty(key)) {
                uri.setQuery(key, queryStringObject[key]);
            }
        }

        return uri.toString();
    }

    public static getPacketsMode(uriObj?: Object): boolean {
        uriObj = Utils.valueOrDefault(uriObj, Utils.getURIQuery());
        return Utils.valueOrDefault(uriObj['packets'], false);
    }

    public static getPacketSetName(uriObj?: Object): string {
        uriObj = Utils.valueOrDefault(uriObj, Utils.getURIQuery());
        return Utils.valueOrDefault(uriObj['packetSet'], null);
    }

    public static updateHashGroupValue(name: string, value: string): void {
        var groups = this.getHashGroups();
        var item: IHashItem = _find(groups, group => StringUtils.equals(group.name, name, true));
        if (Utils.isNullOrUndefined(item)) {
            item = {
                name: name,
                value: value
            };
            groups.push(item);
        } else {
            item.value = value;
        }

        this.updateHash(groups);
    }

    public static updateHash(groups: Array<IHashItem>): void {
        var fragment: string = '';
        for (var i = 0; i < groups.length; i++) {
            var group = groups[i];
            fragment += `${group.name}=${group.value}`;
            if (i + 1 < groups.length) {
                fragment += '&';
            }
        }

        var oldhash = location.hash;
        var hash = URI().fragment(fragment).hash();
        location.hash = hash;
        console.log(`Update location hash to: "${hash}" (old: "${oldhash}")`);
    }

    public static getHashGroupValue(name: string, defaultValue: string): string {
        var groups = this.getHashGroups();
        if (groups.length > 0) {
            var item = _find(groups, group => StringUtils.equals(group.name, name, true));
            return item ? item.value : defaultValue;
        }
    }

    public static getHashGroups(): Array<IHashItem> {
        var result: Array<IHashItem> = [];
        var fragment = URI().fragment();
        if (fragment) {
            var groups = fragment.split('&');

            _each(groups, group => {
                var groupVals = group.split('=', 2);
                var name = groupVals.length > 0 ? groupVals[0] : '';
                var value = groupVals.length > 1 ? groupVals[1] : '';
                if (!StringUtils.isNullOrEmpty(name)) {
                    result.push({
                        name: name,
                        value: value
                    });
                }
            });
        }

        return result;
    }
}

const isBrowser = typeof window !== 'undefined';

if (isBrowser) {
    (window as any)['URI'] = URI;
}


/** WEBPACK FOOTER **
 ** ./Typescript/Utils/UriHelper.ts
 **/